export const getPath = (params) => {
var path = ''
  if(params.language && params.entryPoint && params.partner){
    path =  `/?language=${params.language}&page=sorry&partner=${params.partner}`
  }
  else if(params.language && params.entryPoint && params.lob){
    path =  `/?language=${params.language}&page=sorry&lob=${params.lob}`
  }
  else if(params.language && params.partner){
    path =  `/?language=${params.language}&page=sorry&partner=${params.partner}`
  }
  else if(params.entryPoint && params.partner){
    path =  `/?entrypoint=${params.entryPoint}&page=sorry&partner=${params.partner}`
  }
  else if(params.language && params.lob){
    path =  `/?language=${params.language}&page=sorry&lob=${params.lob}`
  }
  else if(params.entryPoint && params.lob){
    path =  `/?entrypoint=${params.entryPoint}&page=sorry&lob=${params.lob}`
  }
  else if (params.partner) {
    path =  `/?page=sorry&partner=${params.partner}`
  }
  else if (params.lob) {
    path =  `/?page=sorry&lob=${params.lob}`
  }
  else{
    path =  `/?page=sorry&partner=gpcc`
  }
 return path;
}